/*
 * @Author: cryi.liu
 * @Date: 2020-05-12 13:48:52
 * @LastEditTime: 2020-09-11 15:55:07
 * @Description: 考试中心 service
 */
import BaseService from './base.service';

export default class extends BaseService {
  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试题库获取筛选条件目录
   */
  async libraryFilterMenu(data = {}) {
    const url = this.API.examcenter.libraryFilterMenu;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试题库获取专属型号筛选条件
   */
  async libraryFilterProductList(data = {}) {
    const url = this.API.examcenter.libraryFilterProductList;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试题库分页获取题库列表
   */
  async libraryList(data = {}) {
    const url = this.API.examcenter.libraryList;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试题库删除题目
   */
  async libraryDeleteQuestion(data = {}) {
    const url = this.API.examcenter.libraryDeleteQuestion;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {String} params
   * @func 试题库导出题库题目
   */
  async libraryExportQuestion(params = '') {
    const filename = '题库列表';
    const url = this.API.examcenter.libraryExportQuestion;
    const requestUrl = `${url}?${params}`;
    const result = await this.downloadExcelFileOfQuery(requestUrl, 'post', filename);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 待编辑题目列表
   */
  async libraryWaitEditList(data = {}) {
    const url = this.API.examcenter.libraryWaitEditList;
    const result = this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 题库题目详情
   */
  async libraryQuestionDetail(data = {}) {
    const url = this.API.examcenter.libraryQuestionDetail;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 修改保存题库题目信息
   */
  async librarySaveQuestion(data = {}) {
    const url = this.API.examcenter.librarySaveQuestion;
    const result = await this.jsonPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 一键重新判分
   */
  async libraryReScore(data = {}) {
    const url = this.API.examcenter.libraryReScore;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 保存待编辑多媒体题目为已编辑多媒体题目
   */
  async librarySaveStatus(data = {}) {
    const url = this.API.examcenter.librarySaveStatus;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 题目详情删除选项
   */
  async libraryDeleteOption(data = {}) {
    const url = this.API.examcenter.libraryDeleteOption;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试卷详情信息
   */
  async paperDetailInfo(data = {}) {
    const url = this.API.examcenter.paperDetailInfo;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试卷详情人员列表
   */
  async paperPersonList(data = {}) {
    const url = this.API.examcenter.paperPersonList;
    const result = this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @param {String} params
   * @func 试卷详情列表导出
   */
  async paperDetailExport(data = {}, params = '') {
    const filename = `试卷详情列表(${data.name})`;
    const url = `${this.API.examcenter.paperDetailExport}?${params}`;
    const result = this.downloadExcelFileOfQuery(url, 'post', filename);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试卷详情删除考生信息
   */
  async paperDeleteByPerson(data = {}) {
    const url = this.API.examcenter.paperDeleteByPerson;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试卷详情考生基本信息
   */
  async paperDetailPersonInfo(data = {}) {
    const url = this.API.examcenter.paperDetailPersonInfo;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 试卷详情考生答题详情
   */
  async paperDetailAnswerDetail(data = {}) {
    const url = this.API.examcenter.paperDetailAnswerDetail;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 试卷详情考生答题简答题分数修改
   */
  async paperDetailUpdateShortScore(data = {}) {
    const url = this.API.examcenter.paperDetailUpdateShortScore;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} params
   * @func 创建考试获取当前索引
   */
  async paperCreateIndex(params) {
    const url = this.API.examcenter.paperCreateIndex;
    const result = await this.formGetOfQuery(url, params);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷上传必考题
   */
  async paperCreateRequireQuestion(data = {}) {
    const url = this.API.examcenter.paperCreateRequireQuestion;
    const result = await this.multiPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 创建试卷设置大题板块每题分数
   */
  async paperCreateSetScore(data = {}) {
    const url = this.API.examcenter.paperCreateSetScore;
    const result = await this.formPutOfQuery(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {Object} data
   * @func 创建试卷删除大题板块
   */
  async paperCreateDeleteBigQuestion(data = {}) {
    const url = this.API.examcenter.paperCreateDeleteBigQuestion;
    const result = await this.formDeleteOfQuery(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷添加大题板块
   */
  async paperCreateAddBigQuestion(data = {}) {
    const url = this.API.examcenter.paperCreateAddBigQuestion;
    const result = await this.jsonPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷更新大题板块
   */
  async paperCreateUpdateBigQuestion(data = {}) {
    const url = this.API.examcenter.paperCreateAddBigQuestion;
    const result = await this.jsonPutOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷筛选条件型号专属
   */
  async paperCreateProductList(data = {}) {
    const url = this.API.examcenter.paperCreateProductList;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author LUMING.LIU
   * @param {*} data
   * @func 创建试卷筛选条件产品型号列表
   */
  async paperCreateProductCodes(data = {}) {
    const url = this.API.examcenter.paperCreateProductCodes;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author LUMING.LIU
   * @param {*} data
   * @func 创建试卷筛选条件根据年份、难易度、产品组、产品型号获取题目数
   */
  async paperCreateQuestionCountByProductCodes(data = {}) {
    const url = this.API.examcenter.paperCreateQuestionCountByProductCodes;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷筛选条件产品组及对应题数
   */
  async paperCreateQuestionCount(data = {}) {
    const url = this.API.examcenter.paperCreateQuestionCount;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷获取选题统计信息
   */
  async paperCreateQuestionComplete(data = {}) {
    const url = this.API.examcenter.paperCreateQuestionComplete;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} data
   * @func 创建试卷添加考试对象
   */
  async paperCreateAddExamObject(data = {}) {
    const url = this.API.examcenter.paperCreateAddExamObject;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} params
   * @func 创建试卷移除考试对象
   */
  async paperCreateDeleteExamObject(params = {}) {
    const url = this.API.examcenter.paperCreateAddExamObject;
    const result = await this.formDeleteOfQuery(url, params);
    return result;
  }

  /**
   * @author cryi.list-unstyled
   * @param {*} data
   * @func 删除通过上传Excel添加的考试对象
   */
  async paperCreateDeleteExamObjectByExcel(data = {}) {
    const url = this.API.examcenter.paperCreateDeleteExamObjectByExcel;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  /**
   * @author cryi.liu
   * @param {*} params
   * @func 创建试卷完成试卷设置
   */
  async paperCreateDonePaperSetting(data = {}) {
    const url = this.API.examcenter.paperCreateDonePaperSetting;
    const result = await this.formPostOfBody(url, data);
    return result;
  }

  async getApproveStatus(params) {
    const url = this.API.examcenter.approve;
    const result = await this.formGetOfQuery(url, params);
    return result;
  }
}
